"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWipModifiedVsCurrentCa = exports.isWipModified = exports.mutateWipMetadata = void 0;
const _ = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const mutateWipMetadata = ({ wip, currentCreditAgreementId, }) => {
    const newVersion = Number(wip.version) + 0.001;
    const version = String(Math.round(newVersion * 1000) / 1000);
    const mutatedWip = {
        ...wip,
        effectiveFrom: common_1.date.currentEpochMs(),
        effectiveTo: common_1.consts.MAX_TIMESTAMP,
        version,
        id: (0, uuid_1.v4)(),
        _schemaVersion_: common_1.consts.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION,
    };
    delete mutatedWip._note_;
    if (currentCreditAgreementId) {
        mutatedWip._currentCreditAgreementId_ = currentCreditAgreementId;
    }
    else {
        delete mutatedWip._currentCreditAgreementId_;
    }
    return mutatedWip;
};
exports.mutateWipMetadata = mutateWipMetadata;
const isObject = (x) => x && typeof x === 'object';
// returns true if two obje
const isDifferent = (objA, objB, path = '') => {
    let different = false;
    for (const key of new Set([...Object.keys(objA), ...Object.keys(objB)])) {
        const newPath = path ? `${path}.${key}` : key;
        // ignore these keys that are added to CA by UI
        if (key === '_internalIterationKey_') {
            continue;
        }
        // @ts-ignore
        const aVal = objA[key];
        // @ts-ignore
        const bVal = objB[key];
        if (isObject(aVal) && isObject(bVal)) {
            if (isDifferent(aVal, bVal, newPath)) {
                different = true;
            }
        }
        else if (aVal !== bVal) {
            // console.log(`Difference at ${newPath}:`, aVal, 'vs', bVal);
            different = true;
        }
    }
    return different;
};
const isWipModified = (a, b) => {
    // allow for effectiveFrom to be different between them.
    const [aCopy, bCopy] = [a, b].map((x) => _.omit(x, ['effectiveFrom']));
    return isDifferent(aCopy, bCopy);
};
exports.isWipModified = isWipModified;
const isWipModifiedVsCurrentCa = (a, b) => {
    // a wip will have mutated metadata vs current, we can ignore these
    const [aCopy, bCopy] = [a, b].map((x) => _.omit(x, [
        'effectiveFrom',
        'version',
        'id',
        '_note_',
        '_currentCreditAgreementId_',
        'borrowingBaseMechanics.calcAgentMechanics._artifactDocumentId_',
    ]));
    return isDifferent(aCopy, bCopy);
};
exports.isWipModifiedVsCurrentCa = isWipModifiedVsCurrentCa;
//# sourceMappingURL=wip.js.map